import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();

  const handleTermsClick = () => {
    navigate('/terms-and-conditions');
  };

  const handlePrivacyClick = () => {
    navigate('/privacy-policy');
  };

  const handleForumClick = () => {
    navigate('/forum');
  };

  const handleBlogClick = () => {
    navigate('/blog');
  };

  const handleRemoteIndustryTopSelectionClick = () => {
    navigate('/remote-industry-top-selection');
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleHowItWorksClick = () => {
    navigate('/how-it-works');
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Your Personal Career Copilot</h3>
            <p>Connecting talented professionals with opportunities. Discover jobs, showcase your skills, and advance your career.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><button onClick={handleHomeClick} className="footer-link">Home</button></li>
              <li><button onClick={handleRemoteIndustryTopSelectionClick} className="footer-link">Remote Industry Top Selection</button></li>
              <li><button onClick={handleHowItWorksClick} className="footer-link">How It Works</button></li>
              <li><button onClick={handleBlogClick} className="footer-link">Blog</button></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              <li><button onClick={handleTermsClick} className="footer-link">Terms of Service</button></li>
              <li><button onClick={handlePrivacyClick} className="footer-link">Privacy Policy</button></li>
              <li><button onClick={handleForumClick} className="footer-link">Forum</button></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>📧 info@remotebirdy.com</p>
            <div className="social-links">
              <a href="https://www.facebook.com/RemoteBirdy" target="_blank" rel="noopener noreferrer" className="social-link">Facebook</a>
              <a href="https://twitter.com/RemoteBirdy" target="_blank" rel="noopener noreferrer" className="social-link">X</a>
              <a href="https://www.instagram.com/RemoteBirdy" target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 Your Personal Career Copilot. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
